export class Sprite3DRenderDeclaration {
}
